module.exports = __webpack_public_path__ + "media/icons/center-b3705c91.svg";